import React from 'react';
import { alnumIdToColor, getAccessibleBadgeColors } from '../../Utils';
import styles from './ChatStudentBadge.module.css';
import { ThemeMode, useProviderTheme } from '../../hooks';

export interface ChatStudentBadgeProps {
  userId: string;
  displayName: string;
}

export const ChatStudentBadge: React.FC<ChatStudentBadgeProps> = ({ userId, displayName }) => {
  const theme = useProviderTheme();
  const colors =
    theme.mode === ThemeMode.HighContrast
      ? undefined
      : getAccessibleBadgeColors(alnumIdToColor(userId));

  return (
    <span
      className={styles.ChatStudentBadge}
      style={{
        color: colors?.color,
        borderColor: colors?.color,
        backgroundColor: colors?.backgroundColor,
      }}
      aria-hidden="true"
    >
      {displayName}
    </span>
  );
};
